module.exports = __webpack_public_path__ + "media/hover.4025075a.mp3";